<template>
  <div class="about-page">
    <h1>About</h1>
  </div>
</template>
<script>
    export default
    {
        name: 'About',
        data ()
        {
            return {
                message: "About me"
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/about.vue